import { SET_ACCOUNTING, SET_ACCOUNTING_TYPES, SET_ACCOUNTINGS } from "../../constants/accountingConstants";

export const setAccountingTypes = (accountingTypes, type) => {
  return {
    type: SET_ACCOUNTING_TYPES,
    accountingTypes,
    accountingTypeTitle: type,
  };
};

export const setAccounting = (accounting) => {
  return {
    type: SET_ACCOUNTING,
    accounting,
  };
};

export const setAccountings = (accountings, filtered = false) => {
  return {
    type: SET_ACCOUNTINGS,
    accountings,
    filtered,
  };
};
